import { useMemo } from 'react';
import PropTypes from 'prop-types';
import { FormField, Label, FormHelp, INPUT_SIZES } from '@zillow/constellation';
import uniqueId from 'lodash/uniqueId';

export const LabeledInput = ({
    InputComponent,
    className,
    error,
    renderLabel,
    children,
    required,
    id,
    testId,
    description,
    ...props
}) => {
    // ToggleButtonGroup / ButtonGroup is not considered a form element by Constellation and thus
    // doesn't have aria-labelledby wired up automatically by Constellation, so we explicitly
    // construct it and provide it to renderLabel / control.
    const labelID = useMemo(() => uniqueId('label_'), []);
    return (
        <FormField
            data-test-id={testId}
            className={className}
            required={required}
            controlId={id ?? props.name}
            label={renderLabel({ id: labelID, children })}
            control={<InputComponent error={error} aria-labelledby={labelID} {...props} />}
            description={(error && <FormHelp error>{error.message}</FormHelp>) || description}
        />
    );
};

LabeledInput.SimpleLabel = props => <Label {...props} />;

LabeledInput.SimpleLabel.propTypes = {
    children: PropTypes.node.isRequired,
};

LabeledInput.propTypes = {
    InputComponent: PropTypes.elementType,
    renderLabel: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
    description: PropTypes.node,
    label: PropTypes.node,
    error: PropTypes.shape({
        message: PropTypes.string,
    }),
    required: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.string,
    testId: PropTypes.string,
};
LabeledInput.defaultProps = {
    renderLabel: LabeledInput.SimpleLabel,
    size: INPUT_SIZES.lg,
};

const withLabel = InputComponent => props => <LabeledInput InputComponent={InputComponent} {...props} />;

export default withLabel;
